<div class="p5 text-center">
        <h3>Hello placeholder</h3>
        <a [routerLink]="['..','files','folder','root']">Files</a> |  <a [routerLink]="['..','project']">Projects</a>
        </div>
    